// extracted by mini-css-extract-plugin
export default {"container":"IJ-z","topReviewHeading":"JJ-z","criticalReview":"KJ-z","favorableReview":"LJ-z","vsSeparator":"MJ-z"};